import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="refresh"
// Auto-reloads the page after `delayValue` ms, showing a visible progress bar
// (the `progress` target) that fills over that same duration. Tapping the
// element (see the `skip` action) continues immediately instead of waiting.
export default class extends Controller {
    static targets = ["progress"];

    static values = {
        delay: { type: Number, default: 4000 },
    };

    connect() {
        this.startProgress();

        this._timeout = setTimeout(() => {
            this.reload();
        }, this.delayValue);
    }

    disconnect() {
        this.clearTimer();
    }

    // Fills the progress bar from 0% to 100% over delayValue, in sync with the reload timer.
    startProgress() {
        if (!this.hasProgressTarget) return;

        this.progressTarget.style.transitionDuration = `${this.delayValue}ms`;

        // Force layout so the browser registers the 0% starting width before animating.
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.progressTarget.style.width = "100%";
            });
        });
    }

    // Tap-to-continue: skip the remaining wait and reload right away.
    skip() {
        this.reload();
    }

    reload() {
        this.clearTimer();
        window.location.reload();
    }

    clearTimer() {
        if (this._timeout) clearTimeout(this._timeout);
    }
}
